import {
  getItemSku,
  getDiscount,
  getItemCategory,
  getItemCategory2,
  getItemCategory4,
  getItemShippingTier,
  resizeVtexImage,
} from '../../utils';
import { appendCartHistory, resolveItemId, resolveItemListName } from '../../utils/itemListAttribution';

export async function itemsFromItem(context: Record<string, any>, event: string) {
  const { item, orderForm, itemListName } = context;
  const resolvedListName = resolveItemListName({ event, item, itemListName });
  const resolvedItemId = resolveItemId(item);

  if (event === 'ADD_TO_CART') {
    appendCartHistory(resolvedItemId, resolvedListName);
  }

  return [
    {
      index: typeof item?.index === 'number' ? item.index : null,
      quantity: 1,
      item_id: item?.productId|| item?.item_group_id || item?.item_id || item?.id || null,
      item_category2: getItemCategory2(item),
      item_category4: getItemCategory4(item),
      item_shipping_tier: event === 'REMOVE_FROM_CART' ? getItemShippingTier(orderForm, item) : null,
      price: item?.price || 0,
      item_ref: item?.ref || item?.refId || item?.item_ref || item?.additionalProperty?.find((i: { name: string }) => i.name === "RefId").value || item?.itemOffered?.gtin.substring(0, item?.itemOffered?.gtin.lastIndexOf('_')) || null,
      item_brand: item?.additionalInfo?.brandName || item?.item_brand || item?.brand?.name || item?.itemOffered?.brand?.name || null,
      item_sku: item?.sku || item?.itemOffered?.sku || (await getItemSku(item)) || null,
      item_name: item?.name?.replace(item?.skuName, '').trim() || item?.name?.split(' - ').shift() || item?.item_name?.split(' - ').shift() || item?.itemOffered?.isVariantOf?.name?.split(' - ').shift() || null,
      item_category: getItemCategory(item) || null,
      // item_variant: (item?.skuName || item?.item_variant || item?.name || item?.itemOffered.name).split(/[-/]/)[0].trim() || null,
      item_variant: (item?.skuName || item?.item_variant || item?.name || item?.itemOffered.name).split(' - ')[0]?.trim() || null,
      // item_variant2: item?.size || item?.itemAttributes?.size || (item?.skuName || item?.name || item?.itemOffered.name)?.split(/[-/]/).pop()?.trim() || null,
      item_variant2: item?.size || item?.itemAttributes?.size || (item?.skuName || item?.name || item?.itemOffered.name)?.split(' - ')[1]?.trim() || null,
      discount: getDiscount(item),
      item_list_name: resolvedListName,

      item_url: item?.item_url || null, // add_to_cart dito
      image_url: resizeVtexImage(item?.image) || resizeVtexImage(item?.imageUrl) || null,
    },
  ];
}
 
